import ViewBase from "./view-base.view";


/**
 * Unauthorized Page
 *
 * Default page to be shown when user is trying to enter a page
 * that he/she does not have access to.
 * 
 * At this point, user should already be automatically logged out.
 *
 * @author Darrus Goh
 */
export default function UnauthorizedView() {
  ViewBase.call(this);

  return {
    view: () => m('.text-center.pt-5',
      m('.mb-3', this.getText('EM00000388', 'You are not authorized to access this page.'),
        m('div',
          m(m.route.Link, { href: '/login' }, this.getText('EM00000812', 'Please login again')),
        )
      )
    )
  };
}
